import React, { useContext, useId } from "react";
import contract from "../apiContract.json";
import { reviewFieldId } from "./Fields";
import ReviewField from "./ReviewField";
import { ReviewIssueContext } from "./ReviewIssueHint";

const limits = contract.remarksLimits;

function remarksLayout(text) {
  const lines = text.replace(/\r\n?/g, "\n").split("\n");
  const characters = lines.join("").length;
  const printed = [];
  // Generator z fontem cyrylickim zachowuje puste wiersze w polu 5.
  const keepEmpty =
    /[\u0400-\u052f\u2de0-\u2dff\ua640-\ua69f\u1c80-\u1c8f]/u.test(text);
  for (const line of lines) {
    const letters = Array.from(line);
    if (!letters.length && keepEmpty) printed.push("");
    for (let i = 0; i < letters.length; i += limits.columns) {
      printed.push(
        letters
          .slice(i, i + limits.columns)
          .join("")
          .trim(),
      );
    }
  }
  return {
    characters,
    rows: text ? Math.max(lines.length, printed.length) : 0,
    preview: printed.slice(0, limits.rows).join("\n"),
  };
}

export default function CertificateRemarks({
  draft,
  config,
  options,
  fields,
  readOnly,
  onChange,
}) {
  const usageId = useId();
  const errorId = useId();
  const selection = useContext(ReviewIssueContext);
  const showUsage =
    !readOnly ||
    (selection?.editing &&
      (selection.id === reviewFieldId("remarks") ||
        fields.some(({ key }) => selection.id === reviewFieldId(key))));
  const parts = options.remarksParts;
  const text = parts
    ? parts
        .filter(
          ({ key, enabledBy }) =>
            draft[key] && (!enabledBy || config[enabledBy]),
        )
        .map(({ key, prefix }) => prefix + draft[key])
        .join("\n")
    : draft.remarks || "";
  const { characters, rows, preview } = remarksLayout(text);
  const invalid =
    showUsage && (characters > limits.characters || rows > limits.rows);
  const descriptionId = !showUsage
    ? undefined
    : [invalid && errorId, usageId].filter(Boolean).join(" ");
  return (
    <>
      {fields.length > 0 && (
        <div className="premium-remarks-fields">
          {fields.map(({ key, label }) => (
            <ReviewField
              key={key}
              readOnly={readOnly}
              id={reviewFieldId(key)}
              label={label}
              value={draft[key]}
              onChange={(event) => onChange(key, event.target.value)}
            />
          ))}
        </div>
      )}
      <div className="premium-grid premium-remarks-layout">
        <ReviewField
          id={reviewFieldId("remarks")}
          label={options.remarksLabel || "Dodatkowe uwagi"}
          multiline
          readOnly={readOnly}
          rows={5}
          value={draft.remarks || ""}
          aria-describedby={descriptionId}
          onChange={(event) =>
            onChange("remarks", event.target.value.replace(/\t/g, " "))
          }
        />
        <div>
          <figure
            className={`premium-remarks-preview${invalid ? " is-invalid" : ""}`}
            aria-invalid={showUsage ? invalid : undefined}
            aria-describedby={descriptionId}
          >
            <figcaption>Podgląd pola 5 na świadectwie</figcaption>
            {!parts ? (
              <p>
                Pełną treść pola 5 zobaczysz w podglądzie świadectwa w kroku 3.
              </p>
            ) : text ? (
              <pre>{preview}</pre>
            ) : (
              <p className="text-muted">Brak uwag.</p>
            )}
          </figure>
          {invalid && (
            <div id={errorId} className="invalid-feedback">
              Skróć treść pola 5. Limit to {limits.characters} znaków i{" "}
              {limits.rows} wierszy, łącznie z wpisami automatycznymi.
            </div>
          )}
          {showUsage && (
            <p id={usageId} className="premium-remarks-usage">
              Znaki {characters} / {limits.characters} · Wiersze {rows} /{" "}
              {limits.rows}
            </p>
          )}
        </div>
      </div>
    </>
  );
}
